export const SUPPORTED_LANGUAGES = ["de", "en", "fr", "it"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = "de";

export const ADMIN_DEFAULT_LANGUAGE: SupportedLanguage = "en";

/** Namespaces used by consumer + vendor surfaces (not admin). */
export const CONSUMER_NAMESPACES = ["common", "consumer", "vendor", "auth"] as const;
export type ConsumerNamespace = (typeof CONSUMER_NAMESPACES)[number];

export const NAMESPACES = [...CONSUMER_NAMESPACES, "admin"] as const;
export type Namespace = (typeof NAMESPACES)[number];

/** Short pill labels for the language switcher. */
export const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
  de: "DE",
  en: "EN",
  fr: "FR",
  it: "IT",
};

/** Endonyms (native names) for menus/settings. */
export const LANGUAGE_NAMES: Record<SupportedLanguage, string> = {
  de: "Deutsch",
  en: "English",
  fr: "Français",
  it: "Italiano",
};

export function isSupportedLanguage(value: unknown): value is SupportedLanguage {
  return typeof value === "string" && (SUPPORTED_LANGUAGES as readonly string[]).includes(value);
}
